import {css} from "lit";
import {commonStyles} from "../common/styles/Common.js";
import {customScrollStyles} from "../common/styles/CustomScrollBar.js";

export const sidebarOutlineStyles = [commonStyles, customScrollStyles, css`
	#btn-bookmark::part(i) {
		background-color: var(--pn-color-bookmark);
	}

	#btn-bookmark {
		cursor: pointer;
	}

	#btn-bookmark:hover::part(i), #btn-bookmark:focus::part(i) {
		background-color: var(--pn-color-bookmark-hover);
	}

	.sidebar-header {
		position: relative;
	}

	.top-section {
		margin: 16px;
		display: flex;
	}

	.views-box {
		-webkit-box-sizing: initial;
		box-sizing: initial;
		height: 32px;
		margin: 0;
		padding: 25px 30px;
		border-top: 1px solid var(--pn-color-border);
		text-align: left;
		display: flex;
		justify-content: space-between;
		align-items: center;

		// Prevent the buttons near the "Project Outline" link from overlapping
		&.intermediate-width .outline-link-view {
			position: static;
			transform: none;
		}

		&.not-displayed {
			display: none;
		}
	}

	.sidebar-outline.integration-proquest .views-box,
	.sidebar-outline.integration-ebsco .views-box,
	.sidebar-outline.integration-gale .views-box {
		justify-content: flex-start;
	}

	.outline-link-view {
		color: #9542FF; /** TODO: var **/
		font-family: var(--pn-headings-font-family);
		line-height: 160%;
	}

	.outline-link-view a {
		font-size: 18px;
		font-weight: 500;
	}

	.right-side-icons {
		display: flex;
		gap: 20px;
		font-size: 20px;
		/** TODO: WCAG target size **/
	}

	.sidebar-outline.integration-proquest .right-side-icons {
		gap: 10px;
	}

	#btn-extra-options::part(button) {
		border-radius: 50%;
		padding: 10px;
		margin: -10px;
	}

	#btn-extra-options::part(button):hover, #btn-extra-options::part(button):focus {
		box-shadow: var(--pn-button-shadow-effect-values);
		outline: none;
	}

	#btn-extra-options::part(button):active {
		box-shadow: inset var(--pn-button-shadow-effect-values);
	}

	.show-extra-options #btn-extra-options::part(button):hover,
	.show-extra-options #btn-extra-options::part(button):focus {
	 	box-shadow: inset var(--pn-button-shadow-effect-values);
	}

	.sidebar-header.show-extra-options #extra-options {
		display: flex;
	}

	#extra-options {
		border-top: 1px solid var(--pn-color-border);
		display: none;
		padding: 10px;
	}

	#options-container {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	#extra-options .option {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	#extra-options .option label {
		width: 100px;
		font-size: var(--pn-font-size-base);
		font-weight: 700;
	}

	#extra-options .options-padding {
		flex: 0 1 70px;
	}

	#main-content {
		box-sizing: border-box;
		border-top: 1px solid var(--pn-outline-border-top-color);
		background: var(--pn-outline-bg-color);
		overflow-y: auto;
		padding-bottom: 109px;
		position: relative;
	}

	#main-content.is-floating {
		height: calc(100vh - 83px); /** height of header section **/
	}
`];
